import { Component, Input, OnInit } from '@angular/core';
import { DisplayService, OmniApi, OmniDashboard } from 'src/app/my-sedgwick';
import { BaseComponent } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-card-dashboard',
    template: `
    <div class="tw-w-full app-pt2 app-pb2">
      <div class="tw-w-full tw-flex tw-flex-wrap">
        <app-new-claims-card
          class="tw-w-full md:tw-w-[33%]"
          [omniDashboard]="omniDashboard"
          [error]="error"
          [translationRequest]="translationRequest"
        />
        <app-return-to-work-card
          class="tw-w-full md:tw-w-[33%]"
          [omniDashboard]="omniDashboard"
          [error]="error"
          [translationRequest]="translationRequest"
        />
        <app-off-work-card
          class="tw-w-full md:tw-w-[34%] "
          [omniDashboard]="omniDashboard"
          [error]="error"
          [translationRequest]="translationRequest"
        >
        </app-off-work-card>
        <div class="tw-w-full tw-flex tw-flex-wrap">
          @if(displayService.accommodationsCard) {
          <app-pending-accommodations-card
            class="tw-w-full md:tw-w-[33%]"
            [omniDashboard]="omniDashboard"
            [error]="error"
            [translationRequest]="translationRequest"
          />
          
          } @else {
          <app-report-claim-card
            class="tw-w-full md:tw-w-[33%]"
            [translationRequest]="translationRequest"
          />
          }

          <app-notifications-card
            class="tw-w-full md:tw-w-[33%]"
            [omniDashboard]="omniDashboard"
            [error]="error"
            [translationRequest]="translationRequest"
          />
          <app-open-claims-card
            class="tw-w-full md:tw-w-[34%]"
            [omniDashboard]="omniDashboard"
            [error]="error"
            [translationRequest]="translationRequest"
          />
        </div>
        <div class="tw-w-full md:tw-w-[33%] tw-flex-col tw-flex-wrap">
          @if(displayService.accommodationsCard) {
          <app-report-claim-card
            class="tw-w-full"
            [translationRequest]="translationRequest"
          />
          }
        </div>
        <div class="tw-w-full md:tw-w-[67%] tw-flex-col tw-flex-wrap">
          <app-comm-center2-card [translationRequest]="translationRequest"/>
          <app-visit-learning-center
            class="tw-w-full containers-min-height"
            [originator]="'summaryDashboard'"
            [translationRequest]="translationRequest"
          />
        </div>
      </div>
    </div>
  `,
    styles: [``],
    standalone: false
})
export class CardDashboardComponent extends BaseComponent implements OnInit {
  @Input()
  translationRequest: TranslationRequest;

  @Input()
  omniDashboard: OmniDashboard = null;

  @Input()
  error: any;

  constructor(private omniApi: OmniApi, public displayService: DisplayService) {
    super();
  }

  async ngOnInit() {
    try {
     // this.omniDashboard = await this.omniApi.getOmniDashboard('',false);
    } catch (error) {
      //this.error = error;
    }
  }
}
